import { Component, OnInit } from '@angular/core';
import { LibraryAssetResult } from 'app/library-assets/models/library-asset-result';
import { ActivatedRoute } from '@angular/router';
import { AssetService } from 'app/library-assets/services/asset.service';
import { AlertService } from 'app/shared/services/alert.service';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { Location } from '@angular/common';

@Component({
  selector: 'dac-asset-result-view',
  templateUrl: './asset-result-view.component.html',
  styleUrls: ['./asset-result-view.component.scss']
})
export class AssetResultViewComponent implements OnInit {

  public disableAsset = true;
  public result:LibraryAssetResult;
  public hasLoadedResults:boolean;

   /**
   * Whether to show the print dialog or not.
   */
  public showPrintDialog:boolean;

  constructor(private route:ActivatedRoute, private assetService:AssetService, private alertService:AlertService, private dacConfig:DacConfig, private location:Location) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let resultId = params['resultId'];
      this.hasLoadedResults = false;
      this.assetService.getAssetResult(resultId).then((result:LibraryAssetResult) => {
        this.hasLoadedResults = true;
        this.result = result;
      })
      .catch((error) => {
        console.error(error);
        if (error && error.status === 404 || error.status === 400) {
          this.alertService.error("404 This item could not be found");
        } else {
          this.alertService.error("There was a server error in loading this item.  Check your internet connection or contact support");
        }
      });
    });
  }
  ngAfterViewInit() {
    // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
    console.log("adding dac-report-loaded class");
    document.body.classList.add("dac-report-loaded");
  }
  public goBack() {
    this.location.back();
  }

  public closePrintDialog() {
    // reset it once we've closed the dialog.
    this.showPrintDialog = false;
  }

  public showCommandButtons() {
      return !this.dacConfig.seamlessMode;
  }

  public print() {
    this.showPrintDialog = true;
  }

  public shouldDisplayExercise() {
    return this.result && this.result.asset.type == 'assignment';
  }

  public shouldDisplayArticle() {
    return this.result && this.result.asset.type == 'article';
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/asset-result-view/asset-result-view.component.ts